import MainSystemFunctional from './MainSystemFunctional'

export default MainSystemFunctional;